import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch { /* retry */ }
      if (tries++ < 8) setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="bg-white rounded-3xl border border-slate-200 shadow-sm p-10 max-w-md w-full text-center" data-testid="payment-result">
        {status === "checking" && (<><Loader2 className="w-14 h-14 text-emerald-600 animate-spin mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold">Zahlung wird geprüft…</h1><p className="text-slate-500 mt-2">Einen Moment bitte.</p></>)}
        {status === "paid" && (<><CheckCircle2 className="w-16 h-16 text-emerald-600 mx-auto mb-4" /><h1 className="font-heading text-2xl font-extrabold text-slate-900">Buchung bestätigt! 🎉</h1><p className="text-slate-500 mt-2">Deine Zahlung war erfolgreich. Der Partner wurde benachrichtigt.</p><Button className="mt-6 bg-emerald-600 hover:bg-emerald-700 w-full" onClick={() => navigate("/meine-buchungen")} data-testid="to-bookings-btn">Zu meinen Buchungen</Button></>)}
        {(status === "error" || status === "timeout") && (<><XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold">Zahlung nicht bestätigt</h1><p className="text-slate-500 mt-2">Bitte prüfe deine Buchungen oder versuche es erneut.</p><Button variant="outline" className="mt-6 w-full" onClick={() => navigate("/meine-buchungen")}>Zu meinen Buchungen</Button></>)}
      </div>
    </div>
  );
}
